export const ToasterActionTypes = {
  SET_TOASTER: "SET_TOASTER",
};
